module.exports = __webpack_public_path__ + "static/media/player_poster.17a76a68.jpg";